import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Account } from "./Main";
import { fetchWithAuth } from "./Utils";
import RegolamentoClassifica from "./componenti/RegolamentoClassifica";
import "./ClassificaMobile.css";
import PopupSfide from "./componenti/PopupSfide";
import PopupTutteSfide from "./componenti/PopupTutteSfide";

const ClassificaMobile = () => {
    const { persona, showAlert } = useContext(Account);

    const [classifica, setClassifica] = useState([]);
    const [utenti, setUtenti] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingAction, setLoadingAction] = useState(null);

    const [nuovoUtente, setNuovoUtente] = useState("");
    const [posizioniTemp, setPosizioniTemp] = useState({});

    const [utenteInClassifica, setUtenteInClassifica] = useState(false);
    const [miaPosizione, setMiaPosizione] = useState(undefined);

    const canView = !!persona?.maestro || utenteInClassifica;

    useEffect(() => {
        if (!persona?.access_token) return;

        caricaClassifica();
        if (persona?.maestro) caricaUtenti();
    }, [persona?.access_token, persona?.maestro]);

    useEffect(() => {
        aggiornaStatiDerivati(classifica);
    }, [persona?.id]);

    const aggiornaStatiDerivati = (lista) => {
        const myId = Number(persona?.id);
        if (!myId || !Array.isArray(lista)) {
            setUtenteInClassifica(false);
            setMiaPosizione(undefined);
            return;
        }

        const me = lista.find((c) => Number(c.IDUtente) === myId);
        setUtenteInClassifica(!!me);
        setMiaPosizione(me ? Number(me.posizione) : undefined);
    };

    const apri_regolamento = () => {
        document.querySelector("#regolamento")?.classList.remove("chiuso");
    };

    const apri_mie_sfide = () => {
        document.querySelector("#popup-sfide")?.classList.remove("chiuso");
    };

    const chiudi_mie_sfide = () => {
        document.querySelector("#popup-sfide")?.classList.add("chiuso");
        caricaClassifica();
    };

    const apri_tutte_sfide = () => {
        document.querySelector("#popup-tutte-sfide")?.classList.remove("chiuso");
    };

    const chiudi_tutte_sfide = () => {
        document.querySelector("#popup-tutte-sfide")?.classList.add("chiuso");
        caricaClassifica();
    };

    const caricaClassifica = async () => {
        setLoading(true);
        const res = await fetchWithAuth("classifica_mobile_get.php", { method: "GET" });

        if (res?.ok && Array.isArray(res.classifica)) {
            const norm = res.classifica.map((r) => ({
                ...r,
                IDUtente: Number(r.IDUtente),
                posizione: Number(r.posizione),
            }));

            setClassifica(norm);
            aggiornaStatiDerivati(norm);
        } else {
            showAlert("Errore", res?.error || "Errore caricamento classifica");
            setClassifica([]);
            setUtenteInClassifica(false);
            setMiaPosizione(undefined);
        }

        setLoading(false);
    };

    const caricaUtenti = async () => {
        const res = await fetchWithAuth("visualizza_utenti.php", { method: "GET" });
        if (res?.ok && Array.isArray(res.utenti)) setUtenti(res.utenti);
    };

    const sfidaGiocatore = async (idSfidato) => {
        const res = await fetchWithAuth("classifica_mobile_sfida.php", {
            method: "POST",
            body: JSON.stringify({ sfidato_id: idSfidato }),
        });

        if (res?.ok) {
            showAlert("Successo", "Sfida lanciata");
            caricaClassifica();
        } else {
            showAlert("Errore", res?.error || "Errore");
        }
    };

    const confermaCambioPosizione = async (idUtente, modalita) => {

        const nuovaPosizione = posizioniTemp[idUtente];

        if (loadingAction !== null) return;

        if (!Number.isInteger(nuovaPosizione) || nuovaPosizione < 1) {
            showAlert("Errore", "Inserisci una posizione valida");
            return;
        }

        setLoadingAction(idUtente);

        try {
            const res = await fetchWithAuth("classifica_mobile_move.php", {
                method: "POST",
                body: JSON.stringify({
                    IDUtente: idUtente,
                    posizione: nuovaPosizione,
                    modalita: modalita,
                }),
            });

            if (res?.ok) {
                showAlert("Successo", "Posizione aggiornata");
                caricaClassifica();
            } else {
                showAlert("Errore", res?.error || "Errore");
            }

        } finally {
            setLoadingAction(null);
        }
    };

    const rimuoviDaClassifica = async (idUtente) => {
        if (!window.confirm("Rimuovere il giocatore dalla classifica?")) return;

        const res = await fetchWithAuth("classifica_mobile_remove.php", {
            method: "POST",
            body: JSON.stringify({ IDUtente: idUtente }),
        });

        if (res?.ok) {
            showAlert("Successo", "Giocatore rimosso");
            caricaClassifica();
        } else {
            showAlert("Errore", res?.error || "Errore");
        }
    };

    const aggiungiInClassifica = async () => {
        if (!nuovoUtente) return;

        const res = await fetchWithAuth("classifica_mobile_add.php", {
            method: "POST",
            body: JSON.stringify({ IDUtente: nuovoUtente }),
        });

        if (res?.ok) {
            showAlert("Successo", "Giocatore aggiunto");
            setNuovoUtente("");
            caricaClassifica();
        } else {
            showAlert("Errore", res?.error || "Errore");
        }
    };

    const myId = Number(persona?.id);
    const isLoading = loadingAction !== null;

    return (
        <>
            <Helmet>
                <title>Sporting - Classifica mobile</title>
                <meta
                    name="description"
                    content="Partecipa alla classifica mobile di Sporting Saluzzo."
                />
            </Helmet>
            <div id="classifica-mobile">
                <div className="classifica-header">
                    <div className="classifica-row top">
                        <h1 className="classifica-title">Classifica Mobile</h1>
                        <button onClick={apri_regolamento}>Regole</button>
                    </div>

                    {canView && !loading && (
                        <div className="classifica-row bottom">
                            <button onClick={apri_tutte_sfide}>Tutte le sfide</button>
                            <button onClick={apri_mie_sfide}>Le mie sfide</button>
                        </div>
                    )}
                </div>

                {canView && !loading && (
                    <>
                        <PopupSfide onClose={chiudi_mie_sfide} onAggiornaClassifica={caricaClassifica} />
                        <PopupTutteSfide onClose={chiudi_tutte_sfide} onAggiornaClassifica={caricaClassifica} />
                    </>
                )}

                <RegolamentoClassifica />

                {loading && <p>Caricamento...</p>}

                {!persona?.maestro && !utenteInClassifica && !loading && (
                    <p style={{ textAlign: "center", padding: 30, marginTop: 100, marginBottom: 200 }}>
                        Contatta l'amministratore per entrare nella classifica mobile
                    </p>
                )}

                {canView && !loading && (
                    <div className="lista-classifica">
                        {classifica.map((g) => {
                            const puoSfidare =
                                utenteInClassifica &&
                                g.IDUtente !== myId &&
                                miaPosizione !== undefined &&
                                g.posizione < miaPosizione &&
                                g.posizione >= miaPosizione - 4;

                            return (
                                <div className={`card-user ${g.IDUtente === myId ? "mia-card" : ""}`} key={g.IDUtente}>
                                    <div className="user-position">
                                        <div style={{ display: "flex", gap: 20, justifyContent: "center", alignItems: "center" }}>
                                            <h1 className="posizione">{g.posizione}</h1>
                                            <h1 className="user-name">
                                                {g.nome} {g.cognome}
                                            </h1>
                                        </div>

                                        {puoSfidare && (
                                            <button className="conferma" onClick={() => sfidaGiocatore(g.IDUtente)}>
                                                Sfida
                                            </button>
                                        )}
                                    </div>

                                    {persona?.maestro && (
                                        <>
                                            <div style={{ display: "flex", gap: 10, justifyContent: "center", alignItems: "center" }}>
                                                <label className="nuova-posizione">Nuova posizione:</label>
                                                <input
                                                    type="number"
                                                    min={1}
                                                    max={classifica.length + 1}
                                                    value={posizioniTemp[g.IDUtente] ?? g.posizione}
                                                    onChange={(e) => {
                                                        const value = parseInt(e.target.value, 10);

                                                        setPosizioniTemp({
                                                            ...posizioniTemp,
                                                            [g.IDUtente]: isNaN(value) ? "" : value,
                                                        });
                                                    }}
                                                />
                                                <button className="rimuovi" onClick={() => rimuoviDaClassifica(g.IDUtente)}>
                                                    -
                                                </button>
                                            </div>
                                            <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 15, alignItems: "center" }}>
                                                <button
                                                    className="conferma"
                                                    disabled={isLoading}
                                                    onClick={() => confermaCambioPosizione(g.IDUtente, "swap")}
                                                >
                                                    {isLoading ? "🔁 Scambiando..." : "🔁 Scambia"}
                                                </button>

                                                <button
                                                    className="conferma"
                                                    disabled={isLoading}
                                                    onClick={() => confermaCambioPosizione(g.IDUtente, "shift")}
                                                >
                                                    {isLoading ? "📥 Inserendo..." : "📥 Inserisci"}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {persona?.maestro && canView && (
                    <div style={{ marginBottom: 30 }}>
                        <hr />
                        <h2 style={{ textAlign: "center" }}>Aggiungi giocatore alla classifica</h2>

                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <select style={{ marginBottom: 0 }} value={nuovoUtente} onChange={(e) => setNuovoUtente(e.target.value)}>
                                <option value="">-- seleziona utente --</option>
                                {utenti.map((u) => (
                                    <option key={u.IDUtenti} value={u.IDUtenti}>
                                        {u.cognome} {u.nome}
                                    </option>
                                ))}
                            </select>

                            <button className="conferma" style={{ marginLeft: 10 }} onClick={aggiungiInClassifica}>
                                Aggiungi
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ClassificaMobile;
